import { Button, Col, Divider, Modal, Progress, Row } from "antd";

const ConfirmTestId = ({
  formResponse,
  openModal,
  setOpenModal,
  confirmFormSubmit,
}) => {
  return (
    <Modal
      title="Test Ride - Data Availability"
      open={openModal}
      onCancel={() => setOpenModal(false)}
      footer={null}
      width={500}
    >
      <Row>
        <Col span={24}>
          <Divider className="hr-margin" />
          <Row className="mt1 flex-center">
            <Col span={8} className="bold">
              BMS Data:
            </Col>
            <Col span={12} className="value">
              <Progress
                percent={formResponse?.bmsData}
                strokeColor={{
                  "0%": "#108ee9",
                  "100%": "#87d068",
                }}
              />
            </Col>
          </Row>
          <Row className="mt1 flex-center">
            <Col span={8} className="bold">
              Motor Data:
            </Col>
            <Col span={12} className="value">
              <Progress
                percent={formResponse?.motorData}
                strokeColor={{
                  "0%": "#108ee9",
                  "100%": "#87d068",
                }}
              />
            </Col>
          </Row>
          <Row className="mt1 mb05 flex-center">
            <Col span={8} className="bold">
              TCU Data:
            </Col>
            <Col span={12} className="value">
              <Progress
                percent={formResponse?.tcuData}
                strokeColor={{
                  "0%": "#108ee9",
                  "100%": "#87d068",
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Divider className="hr-margin" />

      <Row justify="end">
        <Col span={8} className="text-center">
          {formResponse?.testId === null ? (
            "Insufficient Data"
          ) : (
            <Button
              data-testid="confirm"
              type="primary"
              className="mt025 submit-btn"
              htmlType="submit"
              onClick={() => confirmFormSubmit()}
            >
              Confirm
            </Button>
          )}
        </Col>
      </Row>
    </Modal>
  );
};

export default ConfirmTestId;
